'use strict';
const angular = require('angular');
const {isNumber} = angular;

export function FirebaseQueueDispatcherProvider() {
  let TIMEOUT_ERROR = 240000; // 4 minutes

  this.defaultTimeout = function (timeout) {
    if (isNumber(timeout)) {
      TIMEOUT_ERROR = timeout;
    } else {
      return TIMEOUT_ERROR;
    }
  };

  this.$get = [
    function () {
      function FirebaseQueueDispatcher() {

      }

      return new FirebaseQueueDispatcher();
    }];
}



// WEBPACK FOOTER //
// ./src/js/_libs/firebase-mq/FirebaseQueueDispatcher.js